<script>
	import Index from '~/pages/_lang/about/index'

	export default Index
</script>